module.exports = __webpack_public_path__ + "d28f8fefa4e850fecd5054c9ce86cfdf.pdf";